import { motion } from 'framer-motion'
import { Box } from '@chakra-ui/react'
import { type ComponentProps } from 'react'

export const MotionChakraBox = motion(Box)
export type MotionChakraBoxProps = ComponentProps<typeof MotionChakraBox>
